import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import fa from './locales/fa.json';
import ar from './locales/ar.json';

// RTL languages
const RTL_LANGS = ['fa', 'ar'];

export function applyDirection(lang) {
  const dir = RTL_LANGS.includes(lang) ? 'rtl' : 'ltr';
  document.documentElement.setAttribute('dir', dir);
  document.documentElement.setAttribute('lang', lang);
}

// All translation bundles we ship — superset of what the DB may enable
const ALL_RESOURCES = {
  en: { translation: en },
  fa: { translation: fa },
  ar: { translation: ar },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: ALL_RESOURCES,
    fallbackLng: 'en',
    // Start permissive — will be narrowed below once we know active languages from the DB
    supportedLngs: Object.keys(ALL_RESOURCES),
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    interpolation: { escapeValue: false },
  });

i18n.on('languageChanged', applyDirection);
applyDirection(i18n.language);

// Fetch active languages from the backend.
// - Update supportedLngs to only the active set.
// - If the user's stored language is now inactive, fall back to the store default.
// - Apply the store default language if the user has never chosen one.
const BASE_URL = process.env.REACT_APP_API_URL || '';

fetch(`${BASE_URL}/api/languages/`)
  .then(r => r.json())
  .then(langs => {
    if (!Array.isArray(langs) || langs.length === 0) return;

    const activeCodes = langs.map(l => l.code);
    const defaultLang = langs.find(l => l.is_default)?.code || activeCodes[0];

    // Narrow i18next to only active languages
    i18n.options.supportedLngs = activeCodes;

    const storedLang = localStorage.getItem('i18nextLng');

    if (!storedLang) {
      // User has never chosen — apply the store default
      if (defaultLang && defaultLang !== i18n.language) {
        i18n.changeLanguage(defaultLang);
      }
    } else if (!activeCodes.includes(storedLang)) {
      // User had a language that is now disabled — reset to store default
      localStorage.removeItem('i18nextLng');
      i18n.changeLanguage(defaultLang);
    }
  })
  .catch(() => {
    // API unreachable — keep whatever language was detected
  });

export default i18n;
